module.exports = __webpack_public_path__ + "img/矩形569.86605b74.png";